export const statusIconMapping = new Map([
  ['Deposit', 'deposit'],
  ['Transfer', 'transfer'],
  ['Withdrawal', 'withdrawal'],
  ['Exchange', 'exchange'],
  ['MassPayout', 'mass-payout'],
  ['Refund', 'refund'],
  ['Balance Adjustment', 'balance-adjustment'],
  ['Card Operation', 'card-operation'],

  ['Successful', 'done'],
  ['Completed', 'done'],
  ['Success', 'done'],
  ['Created', 'new-order'],
  ['In Progress', 'in-progress'],
  ['Cancelled', 'canceled'],
  ['Rejected', 'failed'],
  ['Failed', 'failed'],
  ['Reversed', 'refund-operation'],
  ['Declined', 'failed'],
  ['Temporary', 'in-review'],
  ['Expired', 'expired'],
  ['Refunded', 'refund-operation'],

  ['Validated', 'in-progress'],
  ['Validating', 'in-progress'],
  ['Executing', 'in-progress'],
  ['Executed', 'in-progress'],
]);
